import { Button, Col, Input, Row, Select } from "antd";
import downArrow from "../../../Assets/campagin/downArrow.svg";
import { useEffect, useState } from "react";
import { CheckOutlined, CloseOutlined, DownOutlined } from "@ant-design/icons";
import API_MANAGER from "../../../API";
import FullScreenLoader from "../../../components/common/FullScreenLoader";
import { useSearchParams } from "react-router-dom";

const SoftRequirementSection = ({
  pickList,
  softData,
  setSoftData,
  handlePostAdvert,
  hardData,
  softSelectedTagsData,
  setSoftSelectedTagsData,
  softCheckSelectedTags,
  setSoftCheckSelectedTags,
  softTagData,
  setSoftTagData,
  softCheckTagItem,
  setSoftCheckTagItem,
  tempSoftData,
  setTempSoftData,
  loading,
  setLoading,
  selectedTagsData,
}) => {
  const [searchParams] = useSearchParams();
  const [softPickListOpen, setSoftPickListOpen] = useState(false);
  const [defaultOpenTag, setDefaultOpenTag] = useState(null);
  const [singleSelectTag, setSingleSelectTag] = useState([]);
  const handlePickListOpen = () => {
    setSoftPickListOpen((prev) => !prev);
  };

  const handleItemClick = (data) => {
    if (softCheckSelectedTags.includes(data?.key)) {
      const updatedArray = softCheckSelectedTags.filter(
        (tagName) => tagName !== data?.key
      );
      setSoftCheckSelectedTags(updatedArray);
      const updatedSelectedTagsData = softSelectedTagsData.filter(
        (item) => item?.key !== data?.key
      );
      setSoftSelectedTagsData(updatedSelectedTagsData);
    } else {
      const updatedArray = [...softCheckSelectedTags, data?.key];
      setSoftCheckSelectedTags(updatedArray);
      const updatedSelectedTagsData = [...softSelectedTagsData, data];
      setSoftSelectedTagsData(updatedSelectedTagsData);
    }
  };
  useEffect(() => {
    const idArray = selectedTagsData.map((obj) => obj?.key);
    setSingleSelectTag(idArray);
  }, [selectedTagsData]);
  // SELECT BUTTON
  const handleSelectButton = () => {
    setSoftPickListOpen((prev) => !prev);
  };

  const handleTagClick = async (item, index) => {
    setDefaultOpenTag(index);
    setLoading(true);
    try {
      const response = await API_MANAGER.getTags(`${item?.key}&sort=name`);

      setSoftTagData(response?.data?.data?.tags);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  const handleTagItemclick = (key, tag) => {
    if (tempSoftData.hasOwnProperty(key)) {
      const idArray = [...tempSoftData[key], tag?.id];
      tempSoftData[key] = idArray;
    } else {
      tempSoftData[key] = [tag?.id];
      const updatedArray = [...softCheckTagItem, tag?.id];
      setSoftCheckTagItem(updatedArray);
    }
    setTempSoftData({ ...tempSoftData });
    setSoftData(tempSoftData);
  };
  return (
    <div className="hardRequirementSection_phone">
      <FullScreenLoader isLoading={loading} />
      <Row>
        <Col xs={24}>
          <span className="heading">Soft Requirements</span>
        </Col>
      </Row>
      {/* Choose Requirement box */}
      <Row>
        <Col
          xs={24}
          className="choose_requirement_box"
          onClick={handlePickListOpen}
        >
          <span className="placeholder_text">Choose Requirements</span>
          <DownOutlined />
        </Col>
      </Row>
      {/* All PickList Render When Choose Requirement button is clicked. */}
      {softPickListOpen ? (
        <div className="pickList_main_div">
          <Row className="picklist_row">
            {pickList.map((item, index) => {
              if (!singleSelectTag.includes(item?.key) || item?.mode !== "") {
                return (
                  <Col
                    xs={24}
                    className={
                      softCheckSelectedTags.includes(item?.key)
                        ? "picklist_item active"
                        : "picklist_item"
                    }
                    onClick={() => handleItemClick(item)}
                  >
                    <span>{item?.title}</span>
                    {softCheckSelectedTags?.includes(item?.key) ? (
                      <CheckOutlined />
                    ) : null}
                  </Col>
                );
              }
            })}
          </Row>
          {/* Select and Cancel Button */}
          <Row className="select_cancel_button_section" justify={"center"}>
            <Col xs={24} align={"center"}>
              <Button
                className="select_btn"
                onClick={() => handleSelectButton()}
              >
                Select
              </Button>
            </Col>
            <Col xs={24} align={"center"}>
              <Button className="cancel_button">Cancel</Button>
            </Col>
          </Row>
        </div>
      ) : (
        <div className="selected_pickList_main_div">
          {softSelectedTagsData?.map((item, index) => (
            <div className="main_box">
              <Row>
                <Col xs={24} className="title_row">
                  <span className="title">{item?.title}</span>
                  <CloseOutlined />
                </Col>
                {item?.key !== "CITIZENSHIP" &&
                  item?.key !== "POLICECLEARANCE" &&
                  (item?.key !== "ID_DOCUMENT" ? (
                    <>
                      <Col
                        xs={24}
                        className="pickList_select_col"
                        onClick={() => handleTagClick(item, index)}
                      >
                        <span>Select {item?.title}</span>
                        <DownOutlined />
                      </Col>
                      {defaultOpenTag === index ? (
                        <div className="tagList_main_div">
                          {softTagData?.map((tag) => {
                            let tagName = item?.key;
                            if (hardData.hasOwnProperty(tagName)) {
                              const checkArray = hardData[tagName];
                              if (checkArray.includes(tag?.id)) {
                                return (
                                  <Col
                                    className={"tag_col disabled"}
                                    span={24}
                                    // onClick={() =>
                                    //   handleTagItemclick(item?.key, tag)
                                    // }
                                  >
                                    {tag?.name}
                                  </Col>
                                );
                              }
                            }
                            if (tempSoftData.hasOwnProperty(tagName)) {
                              const checkArray = tempSoftData[tagName];

                              if (checkArray.includes(tag?.id)) {
                                return (
                                  <Col
                                    className={"tag_col active"}
                                    span={24}
                                    onClick={() =>
                                      handleTagItemclick(item?.key, tag)
                                    }
                                  >
                                    {tag?.name}
                                    <CheckOutlined />
                                  </Col>
                                );
                              } else {
                                return (
                                  <Col
                                    className={"tag_col"}
                                    span={24}
                                    onClick={() =>
                                      handleTagItemclick(item?.key, tag)
                                    }
                                  >
                                    {tag?.name}
                                  </Col>
                                );
                              }
                            } else {
                              return (
                                <Col
                                  className={"tag_col"}
                                  span={24}
                                  onClick={() =>
                                    handleTagItemclick(item?.key, tag)
                                  }
                                >
                                  {tag?.name}
                                </Col>
                              );
                            }
                          })}
                        </div>
                      ) : null}
                    </>
                  ) : null)}
              </Row>
            </div>
          ))}
        </div>
      )}
      {/* Post Advert Button Section */}
      {!softPickListOpen ? (
        <Row
          className={
            softSelectedTagsData.length <= 1
              ? "post_advert_section_abs"
              : "post_advert_section"
          }
        >
          <Col xs={24}>
            <Button className="post_btn" onClick={() => handlePostAdvert()}>
              {searchParams.get("cloneId")
                ? "+ Clone Advert"
                : "+ Post Advert"}
            </Button>
          </Col>
          <Col xs={24}>
            <Button className="can_btn">Cancel</Button>
          </Col>
        </Row>
      ) : null}
    </div>
  );
};
export default SoftRequirementSection;
